export default "__VITE_ASSET__b434161b__"